import React, { Component } from "react";
import { Container, Grid } from "@material-ui/core";
import AboutDescription from "./AboutDescription";
import "../section-sidebar.css";

const list = [
  {
    title: "About",
    link: "/aboutus/about",
  },
  {
    title: "Vision",
    link: "/aboutus/vision",
  },
  {
    title: "Mission",
    link: "/aboutus/mission",
  },
  {
    title: "Core Values",
    link: "/aboutus/corevalues",
  },
  {
    title: "College At a Glance",
    link: "/aboutus/history",
  },
  {
    title: "Glorious Past",
    link: "/aboutus/past",
  },
  {
    title: "Recognitions",
    link: "/aboutus/icv",
  },
  {
    title: "Certifications",
    link: "/aboutus/certifications",
  },
  // {
  //   title: "You can add more +",
  //   link: "/aboutus/about",
  // },
];

class PanduAbout extends Component {
  state = {
    link: "",
    query: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    const query = this.state.query.trim().toLowerCase();
    const filtered = query
      ? list.filter((el) => el.title.toLowerCase().includes(query))
      : list;

    return (
      <div className="snav-wrap">
        <Container>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <nav className="snav-side">
                <div className="snav-side-head">About Us</div>
                <div className="snav-search">
                  <div className="snav-search-field">
                    <span className="fa fa-search" aria-hidden="true" />
                    <input
                      type="text"
                      className="snav-search-input"
                      placeholder="Search..."
                      value={this.state.query}
                      onChange={(e) =>
                        this.setState({ query: e.target.value })
                      }
                    />
                  </div>
                </div>
                <ul className="snav-side-list">
                  {filtered.length === 0 ? (
                    <li className="snav-side-empty">No matching items</li>
                  ) : (
                    filtered.map((el, index) => (
                      <li
                        key={index}
                        className={`snav-side-item${
                          el.link === `/aboutus/${this.state.link}`
                            ? " active"
                            : ""
                        }`}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <span className="snav-dot" />
                        {el.title}
                      </li>
                    ))
                  )}
                </ul>
              </nav>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9} style={{minHeight: '800px'}}>
              <AboutDescription type={this.state.link} />
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default PanduAbout;
